import { render, staticRenderFns } from "./sliderItemTpl.vue?vue&type=template&id=76f71fcc&lang=html&"
import script from "./sliderItemTpl.vue?vue&type=script&lang=js&"
export * from "./sliderItemTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports